import { Component, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { CpButtonComponent } from './cp-button.component';

@Component({
  selector: 'button[cp-icon-button]',
  template: ` <ng-content></ng-content> `,
  host: {
    'role': 'button',
    'class': `cp-icon-button`,
    '[class.cp-icon-button--blue]': 'isBlue',
    '[class.cp-icon-button--blue-light]': 'isBlueLight',
    '[class.cp-icon-button--blue-alt]': 'isBlueAlt',
    '[class.cp-icon-button--yellow]': 'isYellow',
    '[class.cp-icon-button--small]': 'isSizeSmall',
    '[class.cp-icon-button--regular]': 'isSizeRegular',
  },
})
export class CpIconButtonComponent extends CpButtonComponent {
  constructor(public element: ElementRef, public renderer: Renderer2) {
    super(element, renderer);
  }
}
